<template>
  <v-footer height="auto" color="blue" :absolute="absolute" class="">
    <v-layout justify-center row wrap>
      <v-btn text class="white--text" @click="gotoHome"> Home</v-btn>
      <v-btn text class="white--text" @click="gotoAbout"> About</v-btn>
      <v-btn text class="white--text" @click="gotoProcess"> The Process</v-btn>
      <v-btn text class="white--text" @click="gotoResilience">
        Resilience</v-btn
      >
      <v-btn text class="white--text" @click="gotoDamage"> Damage</v-btn>
      <v-btn text class="white--text" @click="gotoLogin"> AP Login</v-btn>
      <v-btn text class="white--text" @click="gotoInspectorLogin">
        Inspector Login</v-btn
      >
      <v-btn text class="white--text" @click="gotoHelp"> Help</v-btn>
      <v-flex blue lighten-2 py-3 text-center white--text xs12>
        &copy;2020 —
        <strong>North Queensland Strata Title Inspection Program</strong>
        <a
          class="white--text ml-2"
          href="https://www.jcu.edu.au/copyright-and-terms-of-use"
          >Terms of Use</a
        >
      </v-flex>
    </v-layout>
  </v-footer>
  <!-- <v-footer class="blue darken-2 white&#45;&#45;text">
        <v-layout row wrap align-center>
            <v-flex xs12>
                <div class="white&#45;&#45;text ml-3">
                    Made in Collaboration With
                    <a class="white&#45;&#45;text" href="https://jcu.edu.au" target="_blank">James Cook University Australia</a>
                    and <a class="white&#45;&#45;text" href="https://jcu.edu.au/cts">Cyclone Testing Station JCU</a>
                </div>
            </v-flex>
        </v-layout>
    </v-footer>-->
</template>

<script>
import { router } from "../router";

export default {
  props: {
    absolute: {
      type: Boolean,
      required: false
      // default: 'Lucas'
    }
  },

  data: () => ({}),

  methods: {
    gotoHome() {
      router.push("/");
    },
    gotoLogin() {
      router.push("/login");
    },
    gotoHelp() {
      router.push("/faq");
    },
    gotoDamage() {
      router.push("/damage");
    },
    gotoAbout() {
      router.push("/about");
    },
    gotoProcess() {
      router.push("/process");
    },
    gotoResilience() {
      router.push("/resilience");
    },
    gotoPrivacy() {
      router.push("/agreement");
    },
    gotoInspectorLogin() {
      router.push("/ins-login");
    }
  }
};
</script>
